import React, { Component } from 'react';
import BarcodeQRScannerComponent from '../generics/BarcodeScanner';

class InventoryAuditAddItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      times: 1
    };
  }

  componentDidMount(){
     this.inventoryInput.focus();
  }

  close = () => {
    this.setState({ showModal: false });
  };

  open = () => {
    this.setState({ showModal: true });
  };

  handleOnChange = (e) => {
    this.setState({ times: e.target.value })
  }

  handleOnSumbit = (e) => {
    e.preventDefault();
    this.props.searchAndAddItemId(true, this.state.times)
    this.setState({times: 1})
  }

  handleOnAddInventory = (e) => {
    if (this.props.inventory) {
      this.props.onAddInventory(this.state.times)
      this.setState({times: 1})
    }
  }

  handleOnScan = (code, format, times) => {
    this.props.onScanItem(code, format, times)
    this.setState({showModal: false})
  }

  render(){
    return(
        <div className="row">
          <div className="col-9">
            <div className="row">
              <div className="col-12 d-flex justify-content-start">
                <div className={`form-group w-100 ${this.props.itemError ? "has-danger" : ""}`}>
                  <div className="input-group">
                    <div className="input-group-addon">#</div>
                    <form className='d-flex w-100' noValidate onSubmit={this.handleOnSumbit}>
                      <input className='form-control'
                             ref={(input) => { this.inventoryInput = input; }}
                             placeholder="Inventory ID"
                             value={this.props.code}
                             onChange={this.props.onItemIdChange}/>
                    </form>
                  </div>
                  {this.props.itemError? <em id="firstname-error" className="error form-control-feedback">Please enter a valid inventory id</em> : <em></em>}
                </div>
                <div>
                  <span className="btn btn-secondary mr-0" onClick={this.props.loadingInventory? '' : this.props.onClear}><i className="fa fa-times"></i></span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12 d-flex justify-content-start">
              <div className="form-group w-100">
                <input className="form-control" type="text"
                  placeholder="Inventory Item"
                  value={this.props.loadingInventory? 'Loading...' : (this.props.inventory? this.props.inventory.item.name : '' )}
                  disabled='true'/>
              </div>
              <div>
                <span className="btn btn-success mr-0" onClick={this.handleOnAddInventory}><i className="fa fa-plus"></i> Add</span>
              </div>
            </div>
            </div>
          </div>

          <div className="col-3">
            <div className='row w-100'>
              <div className={`d-flex w-100 justify-content-center form-group ${this.state.times < 1 && 'has-danger'}`}>
                <div className="input-group-addon w-40">Repeat </div>
                <input className="form-control" type="number" min='1' placeholder="Times" value={this.state.times} onChange={this.handleOnChange} />
              </div>
            </div>
            <div class='row w-100'>
              <span className="btn btn-primary scan-shipment-item w-100" onClick={this.open}>
                <i className="fa fa-qrcode mr-05" aria-hidden="true"></i>
                <span>Scan</span>
              </span>
              <BarcodeQRScannerComponent
                show={this.state.showModal}
                onHide={this.close}
                onScan={(code, format, times) => this.handleOnScan(code, format, times)}
                scannedItems={this.props.scannedItems}
                multiple_times_allowed={this.props.multiple_times_allowed}
              />
            </div>
          </div>
        </div>
    )
  }
}

export default InventoryAuditAddItem;
